import React from "react";
import { Body } from "./views/Body";
import AboutStore from "data/meta/AboutStore";
import asModal from "lib/modal/asModal";
import useFluxStore from "@armus/use-flux-store";

export const BackboneAboutModule = asModal("About Hybrid Outcomes")(
    () => {
        const state = useFluxStore(() => {
            const api = AboutStore.getApiVersion();
            return {
                client: AboutStore.getClientVersion(),
                api: api.application,
                aggregate: api.aggregate,
                requiredApi: AboutStore.getRequiredApiVersion(),
                meta: api.meta,
                modules: api.modules,
            };
        }, [AboutStore]);
        return <Body {...state} />;
    });



// WEBPACK FOOTER //
// ./app/lib/about/AboutModule.js